
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $ddd22ab0f7d84ba0$exports = {};

$ddd22ab0f7d84ba0$exports = (parcelRequire("daZiC")).getBundleURL('4soxZ') + "color-picker.9d08445e.js";


var $06ccb929e372d0f8$exports = {};

$06ccb929e372d0f8$exports = (parcelRequire("daZiC")).getBundleURL('4soxZ') + "picker.93f595d7.js";


var $8a46ff02c4604179$exports = {};

$8a46ff02c4604179$exports = (parcelRequire("daZiC")).getBundleURL('4soxZ') + "description.83398dbc.js";




//# sourceMappingURL=facies.df3bc64d.js.map
